/* eslint-disable max-len */
var ICON_COMMS_EMAIL = {
  "default": 'M22.161 5.3L14.017 11.564C13.4387 12.0089 12.7296 12.2501 12 12.2501C11.2704 12.2501 10.5613 12.0089 9.983 11.564L1.839 5.3M1.5 4.75H22.5V19.75H1.5V4.75Z',
  v2: true
};

export { ICON_COMMS_EMAIL };
//# sourceMappingURL=ICON_COMMS_EMAIL.js.map
